import { NavLink } from 'react-router-dom';

import '../Styles/Navigation.css';

import NavItem from './NavItem';
import NavCta from './NavCta'


function DesktopNav() {
    return (
      <div className="w-full fixed z-10">
        <nav className="flex flex-row justify-center pt-4">
          <div className="flex items-center align-middle gap-x-6 lg:gap-x-8 px-16 py-3 bg-lightgrey backdrop-blur-md shadow-md rounded-xl ">
            <NavLink to={`/`}>
              <NavItem>Home</NavItem>
            </NavLink>
            <NavLink to={`/Allprojects`}>
            <NavItem>Projects</NavItem>
            </NavLink>
            <NavLink to={`/`}>
            <div className="logo flex pl-6">
              <h1 className='font-heading text-4xl text-dark-900'>LV</h1>
            </div>
            </NavLink>
            <NavLink to={`/About`}>
              <NavItem>About me</NavItem>
            </NavLink>
            {/* <p className="cursor-pointer hover:bg-lightblue-100 py-1 px-3 rounded-xl transition-all">Projects</p>
            <p className="cursor-pointer hover:bg-lightblue-100 py-1 px-3 rounded-xl transition-all">About me</p>
            <div className="h-7 w-px bg-blue-50 rounded-lg"></div> */}
            {/* <button>
              Contact
              <div
              className="group relative flex flex-row items-end justify-center gap-2 bg-transparent text-body font-body font-medium text-dark-900 lg:text-base transition-all duration-300 ease-in-out border-transparent hover:border-dark-900"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
            </div>
            </button> */}
            <div className=''>
            <a href='mailto:lisanneverbeet@outlook.com'><NavCta>Contact</NavCta></a>          
            </div>
           
          </div>
        </nav>
      </div>
    );
  }
  
  export default DesktopNav;